<template lang="html">
  <div
    class="login-dropdown-wrapper"
    :class="{ modStyle: modalDrop }"
    v-click-outside="onClickOutside"
  >
    <!-- <div @click="focusInput()" class="link">
      <div
        v-if="!modalDrop"
        @mouseover="dropdown = true"
        @click="dropdown = true"
        class="link-text"
      >
        {{ $t("main.login") }}
      </div>
    </div> -->
    <div v-if="dropdown || modalDrop" class="dropdown-wrapper">
      <div class="wrapp-welcome">
        <div class="welcome-title">
          {{ $t("login.welcomeBack") }}
          <img
            @click="closeModal()"
            src="@/assets/newImges/icons/hand.svg"
            alt="close-modal-img"
          />
        </div>
        <div class="welcome-txt">{{ $t("login.welcomeBackTxt") }}</div>
      </div>
      <div class="dropdown">
        <!-- <TestInput
            v-for="(dataF, index) in form"
            :key="index"
            v-model="dataF.value"
            :label="$t(dataF.label)"
            :type="dataF.type"
            :error="dataF.error"
            @input="dataF.error = false"
            :style="{
              width: index === 0 || index === 1 ? '48%' : '100%',
              'padding-bottom': '48px',
              'margin-left': index === 1 ? 'auto' : ''
            }"
          /> -->
        <TestInput
          @keydown.enter="login()"
          v-model="user.username"
          ref="usernameInput"
          type="text"
          :label="$t('main.usernameOrEmail')"
          class="regular-input"
        />
        <TestInput
          @keydown.enter="login()"
          v-model="user.password"
          type="password"
          :label="$t('main.password')"
          class="regular-input "
        />
        <!-- <router-link class="fpass" :to="{ name: 'ForgotPassword' }">
          <div @click="closeDropdown()" class="forgot-password">
            {{ $t("main.forgotPassword") }}?
          </div>
        </router-link> -->

        <div class="fpass" :to="{ name: 'ForgotPassword' }">
          <div @click="openForgotPassModal()" class="forgot-password">
            {{ $t("main.forgotPassword") }}?
          </div>
        </div>

        <!-- <div class="btn-facebook btn">
          <img src="@/assets/icons/facebook-img.png" alt="google-logo">
          <span v-html="$t('main.facebookLogin')"></span>
        </div> -->
        <TurnStile :resetToken="resetToken" @set-token="setToken" />
        <div class="btn-wrapper">
          <div @click="login()" class="btn-login btn dark-blue">
            {{ $t("main.login") }}
          </div>
          <!-- <div class="btn-registration btn" @click="openModal()">{{$t('main.registration')}}</div> -->
        </div>
        <div class="alt-txt">{{ $t("login.altTxt") }}</div>
        <div v-google-signin-button="clientId" class="btn-google btn">
          <img src="@/assets/newImges/icons/google.svg" alt="google-logo" />
          <span v-html="$t('main.googleLogin')"></span>
        </div>
        <div class="new-user">
          {{ $t("login.newUser") }}
          <span @click="openRegisterModal">{{
            $t("login.createAccount")
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import eventBus from "@/shared/eventBus.js";
import GoogleSignInButton from "vue-google-signin-button-directive";
import TurnStile from "@/components/TurnStileVue2.vue";
import TestInput from "../shared/testInput.vue";

export default {
  name: "loginDropdown",
  directives: {
    GoogleSignInButton
  },
  components: {
    TurnStile,
    TestInput
  },
  props: {
    modalDrop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dropdown: false,
      // dropdown: true,
      user: {
        username: "",
        password: ""
      },
      localToken: "",
      resetToken: false,
      clientId:
        "604246442681-m9mujciv4kk2tgeh8nrc7vngbcoaprjj.apps.googleusercontent.com"
    };
  },
  mounted() {
    if (this.$refs.usernameInput) {
      this.focusInput();
    }
  },
  methods: {
    openRegisterModal() {
      eventBus.$emit("openModal", { component: "chooseRegistrationModal" });
    },
    closeDropdown() {
      this.dropdown = false;
      eventBus.$emit("closeModal");
    },
    openForgotPassModal() {
      let params = {
        // modalData: { userIsLoged: this.userIsLoged },
        component: "resetPasswordModal"
      };
      eventBus.$emit("openModal", params);
    },
    OnGoogleAuthSuccess(idToken) {
      const params = {
        token: idToken
      };
      api
        .googleLogin(params)
        .then(res => {
          localStorage.setItem("sid", res.data.sid);
          this.$emit("changeLoged", true);
          this.$store.commit("changeUserIsLoged", true);
          localStorage.setItem("userName", res.data.usr_name);
          this.$store.commit("setUserName", res.data.usr_name);
          this.$store.commit("setUserImage", res.data.usr_image);
          this.$store.commit("setDisplayName", res.data.display_name);

          if (res.data.admin && res.data.admin === true) {
            this.$store.commit("setUserAdmin", true);
          } else {
            this.$store.commit("setUserAdmin", false);
          }
          eventBus.$emit("openWSConnection");
          this.$toast.success(this.$t("toast.loginSuccess"), {
            duration: 8000
          });
          eventBus.$emit("refresh");
          this.$store.commit("changeFavoritesLength");

          const onRegister = this.$route.matched.some(
            record => record.name === "Register"
          );
          if (
            this.$route.name === "VerificationDisplay" ||
            this.$route.name === "ForgotPassword" ||
            this.$route.name === "Verification" ||
            onRegister
          ) {
            this.$router.push({ name: "Home" });
          }
        })
        .catch(e => {
          this.$toast.error(this.$t("toast.loginError"), {
            duration: 8000
          });
        });
      // Receive the idToken and make your magic with the backend
    },
    OnGoogleAuthFail(error) {
      console.log(error);
    },
    async login() {
      // await this.$recaptchaLoaded();
      // let token = await this.$recaptcha("login");

      const params = {
        token: this.localToken,
        usr_username: this.user.username,
        usr_password: this.user.password
      };
      // get a new token for the next call
      this.resetToken = !this.resetToken;

      api
        .login(params)
        .then(res => {
          localStorage.setItem("sid", res.data.sid);
          this.$emit("changeLoged", true);
          this.$store.commit("changeUserIsLoged", true);
          localStorage.setItem("userName", res.data.usr_name);
          this.$store.commit("setUserName", res.data.usr_name);
          this.$store.commit("setUserImage", res.data.usr_image);
          this.$store.commit("setDisplayName", res.data.display_name);

          if (res.data.admin && res.data.admin === true) {
            this.$store.commit("setUserAdmin", true);
          } else {
            this.$store.commit("setUserAdmin", false);
          }
          eventBus.$emit("openWSConnection");
          this.$toast.success(this.$t("toast.loginSuccess"), {
            duration: 8000
          });
          eventBus.$emit("refresh");
          this.$store.commit("changeFavoritesLength");
          const onRegister = this.$route.matched.some(
            record => record.name === "Register"
          );
          if (
            this.$route.name === "VerificationDisplay" ||
            this.$route.name === "ForgotPassword" ||
            this.$route.name === "Verification" ||
            onRegister
          ) {
            this.$router.push({ name: "Home" });
          }
        })
        .catch(e => {
          if (e.response.data.status === "verify") {
            this.$router.push({
              name: "Verification",
              params: { usr_name: this.user.username }
            });
            this.dropdown = false;
            // } else if (e.response.data.status === "username") {
            //   this.$toast.error(this.$t("toast.loginErrorUsername"), {
            //     duration: 8000
            //   });
            // } else if (e.response.data.status === "password") {
            //   this.$toast.error(this.$t("toast.loginErrorPassword"), {
            //     duration: 8000
            //   });
          } else {
            this.$toast.error(this.$t("toast.loginError"), {
              duration: 8000
            });
          }
        });
    },
    focusInput() {
      this.$refs.usernameInput.focusInput();
      // this.$refs.usernameInput.$el.children
      //   .find(el => el.tagName === "INPUT")
      //   .focus();
    },
    onClickOutside() {
      this.dropdown = false;
    },
    setToken(e) {
      this.localToken = e;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-overlay > .modal-wrapper {
  max-height: 99vh !important;
  background-color: aquamarine !important;
}
.login-dropdown-wrapper {
  box-sizing: border-box;

  line-height: 100%;
  position: relative;

  text-align: left;
  font-family: Outfit;
  overflow: auto;
  max-height: calc(100% - 20px);
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;

  .link {
    // height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .link-img {
      margin-right: 10px;
      cursor: pointer;
    }
    .link-text {
      cursor: pointer;
      font-style: normal;
      font-weight: bold;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.02em;
      transition-duration: 0.2s;
      color: $text-color;
    }
  }
  .link:hover .link-text {
    color: $text-hover-color;
  }
  .wrapp-welcome {
    .welcome-title {
      font-weight: 600;
      font-style: SemiBold;
      font-size: 36px;
      line-height: 100%;
      letter-spacing: 0%;
      margin-bottom: 30px;
    }
    .welcome-txt {
      font-weight: 500;
      font-style: Medium;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 0%;
      color: $blue-400;
      margin-bottom: 30px;
    }
  }
  .dropdown-wrapper {
    padding: 100px;
    padding-top: 11px;
    padding-right: 10px;
    position: absolute;
    top: 23px;
    right: -10px;
    z-index: 3;
  }
  .dropdown {
    background-color: $gray-blue-400;
    padding: 29px;
    padding-bottom: 26px;
    right: 0px;
    border: 1px solid #ddd;
    z-index: 2;
    width: calc(252px - 58px);
    display: flex;
    flex-direction: column;

    .regular-input {
      margin-bottom: 25px;
    }

    .fpass {
      text-decoration: none;
    }

    .forgot-password {
      font-weight: 400;
      font-style: Regular;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0%;
      text-decoration: underline;
      text-decoration-style: solid;
      text-decoration-thickness: 0%;
      text-align: right;

      cursor: pointer;

      color: $blue-400;
      margin-bottom: 25px;
    }
    .btn-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 30px;

      .btn-login {
        width: 100%;
      }
    }
    .btn {
      span {
        min-width: 140px;
      }
    }
    .btn-google.btn {
      justify-content: center;
      margin-bottom: 30px;
      img {
        margin-right: 10px;
      }
    }
    .alt-txt {
      font-weight: 400;
      font-style: Regular;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0%;
      color: $gray-blue-1300;
      margin-bottom: 30px;
      text-align: center;
    }
  }
  .new-user {
    text-align: center;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    color: $blue-400;
    span {
      text-decoration: underline;
      color: $blue-600;
      cursor: pointer;
    }
  }
}
// .small-nav-wrapper {
//   .link {
//     .link-text {
//       color: white !important;
//       margin-bottom: 20px;
//       margin-right: 0px;
//       font-size: 15px;
//     }
//   }
//   .dropdown-wrapper {
//     padding: 10px;
//     padding-left: 0px;
//     left: -14px;
//     right: auto;
//   }
// }
.modStyle {
  margin-right: 0px !important;
  margin: 0 auto;
  /*  display:flex !important;
    justify-content: center;
    align-items: center;
*/

  .dropdown-wrapper {
    position: initial;
    box-sizing: border-box;
    width: 100%;

    padding: 32px 37px 0;
  }

  .dropdown {
    border: transparent;
    width: 100%;
    padding: 0;
  }
}
@media only screen and (max-width: 768px) {
  .login-dropdown-wrapper {
    .wrapp-welcome {
      .welcome-title {
        font-size: 22px;

        margin-bottom: 20px;
        margin-top: 10px;
        img {
          width: 22px;
          margin-left: 5px;
        }
      }
      .welcome-txt {
        font-size: 16px;
        line-height: 20px;

        margin-bottom: 20px;
      }
    }
    .dropdown-wrapper {
      padding: 0;
    }
    .dropdown {
      display: flex;
      flex-direction: column;

      .regular-input {
        margin-bottom: 20px;
      }

      .fpass {
        text-decoration: none;
      }

      .forgot-password {
        font-weight: 400;
        font-style: Regular;
        font-size: 14px;
        line-height: 22px;

        margin-bottom: 20px;
      }
      .btn-wrapper {
        margin-bottom: 15px;

        .btn-login {
          font-size: 0.95em;
          width: 100%;
          height: 45px;
        }
      }

      .btn-google.btn {
        justify-content: center;
        margin-bottom: 15px;
        img {
          margin-right: 10px;
        }
      }
      .alt-txt {
        font-size: 14px;
        line-height: 22px;
        margin-bottom: 15px;
      }
    }
    .new-user {
      text-align: center;
      font-weight: 400;
      font-style: Regular;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0%;
      color: $blue-400;
      span {
        text-decoration: underline;
        color: $blue-600;
        cursor: pointer;
      }
    }
  }
  .btn-google {
    span {
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>
